//import React from 'react';
//import {render} from 'react-dom';
//import * as ReactDOMClient from 'react-dom/client';
import {createRoot} from 'react-dom/client';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
//import Reboot from '@material/material/core/Reboot';
import { ThemeProvider, createTheme } from '@mui/material/styles';
//import {purple,green,grey,pink,yellow} from '@material/material/core/colors';
import LoginPage from './app/startup/LoginPage';
import HomePage from './app/startup/HomePage';
import {bizpost} from './ajax';
import {createColor} from './app/themes/colors';
import "./index.css";

// Pallete Generator
// See Playground section @ https://mui.com/material-ui/customization/color/
const green = {light:'#5db36e',main:'#35a04a',dark:'#257033',contrastText: '#ffffff'};
const red = {light:'#fb5f74',main:'#fb3852',dark:'#af2739',contrastText: '#ffffff'};
// const blue = {light:'#00AEEF',main:'#1DACD6',dark:'#24419B',contrastText: '#ffffff'};
// const gold = {light:'#decc95',main:'#ffc107',dark:'#664e04',contrastText: '#000000'};
// const lemon = {light:'#c1e312',main:'#b5e312',dark:'#bdde14',contrastText: '#ffffff'};
// const temp = {light:'',main:'',dark:'',contrastText: '#ffffff'};

const theme = createTheme({
  palette: {
    primary: {...green},
    secondary: {...red},
    cocoa: createColor('#964B00'),
    goldy: createColor('#FFD700'),
    lemon: createColor('#BDDE14'),
    oldie: createColor('#757575'),
    pinky: createColor('#D81B60'),
    tealy: createColor('#60D81B'),
  },
});

// const start = async()=>{
//   const logincontext = false;

//   try{
//     const json = {s:'security',a:'basicdata',m:'mfa'};
//     //startLoading();
//     const response = await bizpost(json);
//     console.log('login response ',response);
//     var page;
//     if(!response.bd){
//       page = (<LoginPage home={HomePage} apptheme={theme} logincontext={logincontext} />);
//     }
//     else{
//       page = <HomePage  udata={response} />;
//     }
//   }
//   catch(error){
//     page = <LoginPage home={HomePage} apptheme={theme} logincontext={logincontext} />;
//   }
//   finally{
//     //stopLoading();
//     const container = document.getElementById('app');

//     // Create a root.
//     if(container !== null){
//       const root = createRoot(container);
//       root.render(<ThemeProvider theme={theme}>{page}</ThemeProvider>);
//     }
    
//     //render(<MuiThemeProvider theme={theme}>{page}</MuiThemeProvider>, document.getElementById('app'));
//   }
// }

// start();


const installNavigationGuard = () => {

  if (window.history.state?.bpmmsGuard) {
    return;
  }

  window.history.pushState(
    {
      ...(window.history.state || {}),
      bpmmsGuard: true,
    },
    '',
    window.location.href
  );

  window.addEventListener('popstate', () => {
    window.history.pushState(
      {
        ...(window.history.state || {}),
        bpmmsGuard: true,
      },
      '',
      window.location.href
    );
  });
};

const start = async () => {
  const logincontext = false;

  try {
    const json = {
      s: 'security',
      a: 'basicdata',
      m: 'mfa'
    };

    const response = await bizpost(json);

    console.log('login response ', response);

    var page;

    if (!response.bd) {
      page = (
        <LoginPage
          home={HomePage}
          apptheme={theme}
          logincontext={logincontext}
        />
      );
    }
    else {
      page = (
        <HomePage
          udata={response}
        />
      );
    }
  }
  catch (error) {
    page = (
      <LoginPage
        home={HomePage}
        apptheme={theme}
        logincontext={logincontext}
      />
    );
  }
  finally {

    const container =
      document.getElementById('app');

    if (container !== null) {

      installNavigationGuard();

      const root =
        createRoot(container);

      root.render(
        <ThemeProvider theme={theme}>
          {page}
        </ThemeProvider>
      );
    }
  }
};

start();

/*
if (!response.bd) {
  page = (
    <LoginPage
      home={HomePage}
      apptheme={theme}
      logincontext={logincontext}
    />
  );
}
else {
  installNavigationGuard();

  page = (
    <HomePage
      udata={response}
    />
  );
}
  */